var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 16.25V11.75H14.75L11 7.25L7.25 11.75H10.25V16.25H6.5V16.2125C6.374 16.22 6.254 16.25 6.125 16.25C4.63316 16.25 3.20242 15.6574 2.14752 14.6025C1.09263 13.5476 0.5 12.1168 0.5 10.625C0.5 7.739 2.6825 5.387 5.483 5.0645C5.72853 3.78094 6.41367 2.62305 7.42056 1.79C8.42745 0.956944 9.69317 0.500792 11 0.5C12.307 0.500731 13.5729 0.956829 14.5801 1.78987C15.5872 2.6229 16.2726 3.78082 16.5185 5.0645C19.319 5.387 21.4985 7.739 21.4985 10.625C21.4985 12.1168 20.9059 13.5476 19.851 14.6025C18.7961 15.6574 17.3653 16.25 15.8735 16.25C15.7475 16.25 15.626 16.22 15.4985 16.2125V16.25H11.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.20abacacace74f1ad8ca065a6a5a5bf4.svg";
export { ForwardRef as ReactComponent };